import { Resizable } from 're-resizable';
import { Rnd } from 'react-rnd';
import { useState, useEffect } from 'react';
import { getSprintTopPosition, getTopPositionOfSprint } from '../../../utils/masterHelper';
import { spaceColorBgMapping, sprintColorBgMapping } from '../../../utils/colorBgColorMap';

const defaultCellWidth = 72;
const DraggableItem = (props) => {
    const { currentSprint, sprintDetail, sprints, subLevelIndex, updateSprintDuration, isSubLevel, parentId = '', allowResize = true } = props
    const [actualWidth, setActualWidth] = useState(0)
    const [leftPosition, setLeftPosition] = useState(8)
    const [size, setSize] = useState({
        width: 56,
        height: isSubLevel ? 24 : 32,
    });
    const [position, setPosition] = useState({ x: 8, y: 0 })
    let allowDurationResize = allowResize || (currentSprint.subLevels && currentSprint.subLevels.length === 0) 
    let sprintColor = currentSprint.color || "#0A99FE"

    // let marginLeft = (currentSprint.start - 1) * defaultCellWidth + 8

    useEffect(() => {
        let currentWidth = currentSprint.end - currentSprint.start
        setActualWidth((currentWidth + 1) * defaultCellWidth)
        setLeftPosition((currentSprint.start - 1) * defaultCellWidth + 8)
        setSize({
            width: Number((currentSprint.end - currentSprint.start + 1) * defaultCellWidth - 8),
            height: 36,
        })
        // let itemTopPosition = getSprintTopPosition(sprints, currentSprint.uuid, isSubLevel)
        setPosition({
            x: (Number(currentSprint.start) - 1) * defaultCellWidth,
            y: 0
        })
        
    }, [currentSprint])

    // useEffect(() => {
    //     if(isSubLevel){
    //         let topPosition = 40 + 16 
    //         topPosition = topPosition + (subLevelIndex * topPosition)
    //         setPosition({x : (Number(currentSprint.start) - 1) * defaultCellWidth, y: topPosition})
    //     }
    // },[isSubLevel])

    const handleResize = (e, direction, ref, delta, newPosition) => {
        let addedWeeks = Math.round(delta.width / defaultCellWidth)
        let updatedDuration
        if (direction === 'right') {
            updatedDuration = { start: currentSprint.start, end: Number(currentSprint.end) + addedWeeks }
            // updateSprintDuration(currentSprint.uuid, currentSprint.start, updatedDuration.end, parentId)
        } else {
            let reqStart = Number(currentSprint.start) + Math.abs(addedWeeks); 
            if(newPosition.x < position.x) {
                reqStart = Number(currentSprint.start) - Math.abs(addedWeeks)
            }
            updatedDuration = { start: reqStart, end: Number(currentSprint.end) }
        }
        if(updatedDuration.start <= 0 || updatedDuration.end > sprintDetail.duration) {
            return
        }
        updateSprintDuration(currentSprint.uuid, updatedDuration.start, updatedDuration.end, parentId)

    };

    const handleDrag = (e, d) => {
        let reqStart =  Math.round(d.x / defaultCellWidth) + 1;
        let durationDifference = currentSprint.end - currentSprint.start
        let reqEnd = reqStart  + durationDifference
        if(reqStart <= 0 || reqEnd > sprintDetail.duration) {
            return
        }

        updateSprintDuration(currentSprint.uuid, reqStart, reqEnd, parentId)
    };

    return (
        <Rnd
            size={{ width: size.width, height: size.height }}
            position={{ x: position.x, y: position.y }}
            onDragStop={handleDrag}
            onResizeStop={handleResize}
            dragAxis='x'
            disableDragging={!allowDurationResize}
            enableResizing={{
                top: false,
                right: allowDurationResize,
                bottom: false,
                left: allowDurationResize,
                topLeft: false,
                topRight: false,
                bottomLeft: false,
                bottomRight: false,
            }}
            minWidth={defaultCellWidth}
            maxWidth={defaultCellWidth * Number(sprintDetail.duration)}
        >
            <div
                style={{
                    backgroundColor: isSubLevel ? sprintColorBgMapping[sprintColor] : sprintColor,
                    display: "flex",
                    padding: "5px",
                    height: !isSubLevel ? "32px" : "24px",
                    marginTop: !isSubLevel ? "16px" : 8
                }}
                className='sprint-block'
            >
            </div>

        </Rnd>
    )
}

export default DraggableItem